module.exports = __webpack_public_path__ + "static/media/title_2-02.15051fab.svg";